import { create } from 'zustand'

type ChatStore = {
  query: string
  setQuery: (query: string) => void
  conversationId: string
  setConversationId: (id: string) => void
}

const useChatStore = create<ChatStore>((set) => ({
  query: '',
  setQuery: (query: string) => set({ query }),
  conversationId: '',
  setConversationId: (id: string) => set({ conversationId: id }),
}))

export default useChatStore
